import React from "react";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import type {
    DateOnlyRange,
    DatePickerSelectionMode,
    SingleDatePickerProps,
} from "@design-system/DatePicker/DatePicker.types";

type SharedDatePickerProps = Omit<
    SingleDatePickerProps,
    "mode" | "value" | "onValueChange" | "presets"
>;

interface DatePickerPlaygroundPickerProps {
    mode: DatePickerSelectionMode;
    sharedProps: SharedDatePickerProps;
    dayValue?: string;
    rangeValue?: DateOnlyRange;
    weekValue?: DateOnlyRange;
    monthValue?: DateOnlyRange;
    monthRangeValue?: DateOnlyRange;
    quarterValue?: DateOnlyRange;
    yearValue?: DateOnlyRange;
    onDayChange: (value: string | undefined) => void;
    onRangeChange: (value: DateOnlyRange | undefined) => void;
    onWeekChange: (value: DateOnlyRange | undefined) => void;
    onMonthChange: (value: DateOnlyRange | undefined) => void;
    onMonthRangeChange: (value: DateOnlyRange | undefined) => void;
    onQuarterChange: (value: DateOnlyRange | undefined) => void;
    onYearChange: (value: DateOnlyRange | undefined) => void;
}

export const DatePickerPlaygroundPicker = ({
    mode,
    sharedProps,
    dayValue,
    rangeValue,
    weekValue,
    monthValue,
    monthRangeValue,
    quarterValue,
    yearValue,
    onDayChange,
    onRangeChange,
    onWeekChange,
    onMonthChange,
    onMonthRangeChange,
    onQuarterChange,
    onYearChange,
}: DatePickerPlaygroundPickerProps) => {
    if (mode === "day") {
        return (
            <DatePicker
                {...sharedProps}
                mode="day"
                value={dayValue}
                onValueChange={onDayChange}
            />
        );
    }
    if (mode === "range") {
        return (
            <DatePicker
                {...sharedProps}
                mode="range"
                value={rangeValue}
                onValueChange={onRangeChange}
            />
        );
    }
    if (mode === "week") {
        return (
            <DatePicker
                {...sharedProps}
                mode="week"
                value={weekValue}
                onValueChange={onWeekChange}
            />
        );
    }
    if (mode === "month") {
        return (
            <DatePicker
                {...sharedProps}
                mode="month"
                value={monthValue}
                onValueChange={onMonthChange}
            />
        );
    }
    if (mode === "monthRange") {
        return (
            <DatePicker
                {...sharedProps}
                mode="monthRange"
                value={monthRangeValue}
                onValueChange={onMonthRangeChange}
            />
        );
    }
    if (mode === "quarter") {
        return (
            <DatePicker
                {...sharedProps}
                mode="quarter"
                value={quarterValue}
                onValueChange={onQuarterChange}
            />
        );
    }
    return (
        <DatePicker
            {...sharedProps}
            mode="year"
            value={yearValue}
            onValueChange={onYearChange}
        />
    );
};
